import { React, useEffect, useState } from "react";
import "./jobs.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import { meta } from "../../../content_option";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/js/src/modal";
import Modal from "react-modal";
// import { aniversariosFotos } from "../../../utils/jobs/aniversarios"
import { useLocation, useNavigate } from "react-router-dom";

export const Proyectos = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const project = location.state?.project;

  const [data, setData] = useState(null);

  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalImage, setModalImage] = useState(false);

  useEffect(() => {
    if (!project) {
      console.error("No project specified in location state.");
      return;
    }

    const fetchData = async () => {
      try {
        const proyectNameMin = project.toLowerCase();
        const proyectData = await import(
          `../../../utils/jobs/${proyectNameMin}.js`
        );
        setData(proyectData.default || proyectData); // Maneja exportaciones por defecto
      } catch (err) {
        console.error("Error loading project data:", err);
      }
    };

    fetchData();
  }, [project]); // Ejecuta el efecto cuando `project` cambie

  if (!data) {
    return <div>Loading...</div>; // Manejo de carga
  }

  function openModal(data) {
    setModalImage(data);
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = "#f00";
  }

  function closeModal() {
    setIsOpen(false);
  }

  const onClickHandler = (data) => {
    navigate(`/portfolio`);
  };

  return (
    <HelmetProvider>
      <Container className="About-header">
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            {" "}
            {project} | {meta.title}{" "}
          </title>{" "}
          <meta name="description" content={meta.description} />
        </Helmet>
        <Row className="mb-5 mt-3 pt-md-3">
          <Col lg="8">
            <div className="d-flex justify-content-between align-items-baseline">
              <h1 className="display-4 mb-4 ac_btn btn_modal ac_title"  >{project}</h1>{" "}
              <button
                className="back_btn font-italic font-weight-bold btn ac_btn btn_modal"
                onClick={(event) => onClickHandler(data.title, event)}
              >
                volver
              </button>
            </div>
            <hr className="t_border my-4 ml-0 text-left" />
          </Col>
        </Row>
        <div className="mb-5 po_items_ho">
          {data &&
            data.map((data, i) => {
              return (
                <div key={i} className="po_item">
                  <img src={data.src} alt={data.alt} />
                  <div className="content">
                    <p>{data.description}</p>
                    <button
                      className="btn ac_btn btn_modal"
                      onClick={() => openModal(data.src)}
                    >
                      abrir
                    </button>
                  </div>
                  <Modal
                    isOpen={modalIsOpen}
                    onAfterOpen={afterOpenModal}
                    onRequestClose={closeModal}
                    className="Modal"
                    overlayClassName="Overlay"
                    contentLabel="Example Modal"
                    ariaHideApp={false}
                  >
                  <img src={modalImage} alt={data.alt} />
                  <button className="btn" onClick={closeModal}>
                    x
                  </button>
                  <div class="modal">
                    <div class="modal-header">
                      <button
                        type="button"
                        class="close"
                        data-bs-dismiss="modal"
                      >
                        &times;
                      </button>
                    </div>
                    <div class="modal-body">
                      <button >Palito</button>
                    </div>
                  </div>
                  </Modal>
                </div>
              );
            })}
        </div>
      </Container>
    </HelmetProvider>
  );
};
